// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__OzKUQ","modal":"modal_modal__xRzO3","closeButton":"modal_closeButton__gIFqz"};